import { render, staticRenderFns } from "./dailyPaper1.vue?vue&type=template&id=5b6e6d26&scoped=true"
import script from "./dailyPaper1.vue?vue&type=script&lang=js"
export * from "./dailyPaper1.vue?vue&type=script&lang=js"
import style0 from "./dailyPaper1.vue?vue&type=style&index=0&id=5b6e6d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e6d26",
  null
  
)

export default component.exports